<script lang="ts" setup>
import InsightMenu from '../components/content/InsightMenu.vue';
import InsightList from '../components/content/InsightList.vue';
import { useRoute } from 'vue-router';
import CategoryInsightList from '@/components/content/CategoryInsightList.vue';

const route = useRoute();
</script>

<template>
  <InsightMenu />
  <InsightList v-if="route.path === '/insight'" />
  <CategoryInsightList v-if="route.path === '/insight'" />
</template>
